import {ri} from './runner-idle';

export const click_target = document.getElementById('perception-click-target');

let lastMoved = Date.now();
let clickMeStartDate: number;
export function setClickMeStartDate(date: number) {
  clickMeStartDate = date;
}

click_target?.addEventListener('click', () => {
  // Can't do it if the game is paused
  if (ri.gameSpeed === 0) return;
  ri.stats.perception.addValue(0.05);
  // ri.stats.requestUpdate();
  randomizeLocation();
  ri.focus();
});

function randomizeLocation() {
  lastMoved = Date.now();
  if (click_target) {
    click_target.style.top = `${
      Math.random() * Math.max(270, window.innerHeight)
    }px`;
    click_target.style.left = `${
      Math.random() * Math.max(480, window.innerWidth)
    }px`;
  }
}

setInterval(() => {
  // Can't do it if the game is paused
  if (ri.gameSpeed === 0) return;
  // Make it easier if it's been over 15 minutes and the player hasn't clicked
  if (
    clickMeStartDate &&
    Date.now() - clickMeStartDate > 1000 * 60 * 15 &&
    ri.stats.perception.value.eq(1)
  ) {
    click_target?.classList.add('big');
  } else {
    click_target?.classList.remove('big');
  }
  if (Date.now() - lastMoved < 10 * 1000) return;
  if (Math.random() < 0.1) {
    randomizeLocation();
  }
}, 1000);
